import { TextField } from "@shape-ds/components";
import React, { useState } from "react";
import "./style.scss";
import SearchIcon from "@mui/icons-material/Search";
import FeatureFlagsWrapper from "./FeatureFlagsWrapper";

const FeatureFlagModal: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <div className="ff-modal">
      <p>
        Alterações válidas apenas nessa janela e são desfeitas ao atualizar a
        página, para alterações mais abrangentes e persistentes alterar
        diretamente no{" "}
        <a href="https://us.posthog.com" target="_blank" rel="noreferrer">
          posthog
        </a>
      </p>
      <TextField
        icon={<SearchIcon />}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setSearchTerm(e.target.value)
        }
        placeholder={"search"}
        data-testid="text-filter"
        fullWidth
        InputProps={{ autoComplete: "off" }}
      />
      <FeatureFlagsWrapper searchTerm={searchTerm} type={"AB_TEST"} />
      <FeatureFlagsWrapper searchTerm={searchTerm} type={"FEATURE_FLAG"} />
    </div>
  );
};

export default FeatureFlagModal;
